import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BankService } from '../service/bank.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-bank-update',
  templateUrl: './bank-update.component.html',
  styleUrls: ['./bank-update.component.css']
})
export class BankUpdateComponent implements OnInit {
  obj: any = {
    bankNumber: null,
    bankName: null
  }
  oldName: string = "";
  msgs: any[] = [];
  
  constructor(private route: ActivatedRoute, private dataService: BankService, private router: Router) { }

  ngOnInit() {
    let id = this.route.snapshot.paramMap.get('id');
    let value = this.route.snapshot.paramMap.get('value');
    this.obj.bankNumber = id;
    this.obj.bankName = value;
    this.oldName = value;
  }
  set(newName: string) {
    this.obj.bankName = newName;
    if (this.obj.bankNumber != null || this.obj.bankNumber != undefined) {
      this.dataService.update(this.obj).subscribe((result: any) => {
        if (result == "Success") {
          this.showMessage('success', '', 'העדכון נשמר בהצלחה');
          setTimeout(() => {
            this.router.navigate(['/bank']);
          }, 3000);
        }
        else {
          this.showMessage('error', '', 'תקלה בעדכון');
        }
      },
        (err: HttpErrorResponse) => {
          this.showMessage('error', '', 'תקלה בעדכון');
        });
    }
  }

  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }

}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/bank-update/bank-update.component.ts